export default __webpack_public_path__ + "static/media/valdo-logo-white.d595e8d7.png";